// reducers/analyticsReducer.js
import InitialState from 'Store/InitialState';
import * as types from './ActionTypes';

const analyticsReducer = (state = InitialState.analytics, action) => {
  switch (action.type) {
    
    // ====== INITIALIZATION ======
    case types.ANALYTICS_INIT_REQUEST:
      return {
        ...state,
        isInitializing: true,
        error: null,
      };
      
    case types.ANALYTICS_INIT_SUCCESS:
      return {
        ...state,
        isInitializing: false,
        initialized: true,
        sessionStartTime: Date.now(),
        error: null,
      };
      
    case types.ANALYTICS_INIT_FAILURE:
      return {
        ...state,
        isInitializing: false,
        error: action.payload,
        lastError: action.payload,
        errorCount: state.errorCount + 1,
      };
    
    // ====== PAGE TRACKING ======
    case types.TRACK_PAGE_REQUEST:
      return {
        ...state,
        isTracking: true,
        error: null,
      };
      
    case types.TRACK_PAGE_SUCCESS:
      const trackingData = action.payload;
      return {
        ...state,
        isTracking: false,
        sessionId: trackingData.session_id || state.sessionId,
        currentHitId: trackingData.hit_id || state.currentHitId,
        lastHitId: trackingData.hit_id || state.lastHitId,
        totalPageHits: state.totalPageHits + 1,
        lastTrackingTime: Date.now(),
        error: null,
      };
      
    case types.TRACK_PAGE_FAILURE:
      return {
        ...state,
        isTracking: false,
        error: action.payload,
        lastError: action.payload,
        errorCount: state.errorCount + 1,
      };
    
    // ====== TIME TRACKING ======
    case types.UPDATE_TIME_REQUEST:
      return {
        ...state,
        isUpdatingTime: true,
      };
      
    case types.UPDATE_TIME_SUCCESS:
      return {
        ...state,
        isUpdatingTime: false,
        totalTimeTracked: state.totalTimeTracked + 1,
      };
      
    case types.UPDATE_TIME_FAILURE:
      return {
        ...state,
        isUpdatingTime: false,
      };
    
    // ====== SESSION MANAGEMENT ======
    case types.SET_SESSION_DATA:
      return {
        ...state,
        ...action.payload,
      };
      
    case types.SET_FINGERPRINT:
      return {
        ...state,
        fingerprint: action.payload,
      };
      
    case types.SET_CURRENT_HIT_ID:
      return {
        ...state,
        currentHitId: action.payload,
        lastHitId: action.payload,
      };
      
    case types.CLEAR_SESSION:
      return {
        ...state,
        sessionId: null,
        currentHitId: null,
        lastHitId: null,
        pageStartTime: null,
      };
    
    // ====== CAMPAIGN TRACKING ======
    case types.SET_CAMPAIGN_DATA:
      return {
        ...state,
        campaignId: action.payload.campaign_id || state.campaignId,
        utmData: {
          ...state.utmData,
          ...action.payload,
        },
      };
      
    case types.CLEAR_CAMPAIGN_DATA:
      return {
        ...state,
        campaignId: null,
        utmData: InitialState.analytics.utmData,
      };
    
    // ====== TOKEN MANAGEMENT ======
    case types.SYNC_TOKEN:
      return {
        ...state,
        lastTrackingTime: Date.now(),
      };
      
    case types.TOKEN_CHANGE:
      return {
        ...state,
        sessionId: null,
        currentHitId: null,
        lastTrackingTime: Date.now(),
      };
    
    // ====== PAGE STATE ======
    case types.SET_PAGE_START_TIME:
      return {
        ...state,
        pageStartTime: action.payload,
      };
      
    case types.CLEAR_PAGE_START_TIME:
      return {
        ...state,
        pageStartTime: null,
      };
    
    // ====== ERROR HANDLING ======
    case types.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
      
    case types.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        lastError: action.payload,
        errorCount: state.errorCount + 1,
      };
    
    default:
      return state;
  }
};

export default analyticsReducer;